import React from "react";
import LazyloadImage from "./LazyloadImage";

export default class ThumbImage extends React.Component {
  static defaultProps = {
    containerClassName: 'thumb-image-container',
    desktopWidth: 89
  };

  render() {
    return <LazyloadImage {...this.props} />
  }
}